export const CONSTANTS = {
  STANDARD_THEME: 'theme-standard',
  DARK_THEME: 'theme-dark',
  LOCAL_STORAGE_THEME_KEY: 'theme',
  KEYS: {
    TRAVEL_TO: 'travelTo',
    SECURITY_CHECK: 'securityCheck',
    TRAVEL_FROM: 'travelFrom',
    CUSTOMER_QA: 'customerQA'
  },
  TABS: {
    HOME: 'home',
    DESCRIPTION: 'description',
    COMPONENTS: 'components',
    LOCATION: 'location',
    TASKS: 'tasks',
    SIGNATURE: 'signature',
    MESSAGES: 'messages',
    TIMINGS: 'timings'
  },
  STATUS: {
    PENDING: 'pending',
    COMPLETED: 'completed',
    IN_PROGRESS: 'in-progress',
    NOT_STARTED: 'not-started',
    PAUSED: 'paused',
    SUBMITTED: 'submitted'
  },
  LOCALES: {
    EN: 'en',
    FR: 'fr'
  }
};